import axios from 'axios';
import qs from 'qs';
import { getHost } from './tool';
const getAxiosBase = (baseURL, config) => {
  const axiosBase = axios.create({
    baseURL: baseURL,
    timeout: 15000 // 请求超时时间
  });
  // request拦截器
  axiosBase.interceptors.request.use(
    (config) => {
      config.headers['Content-type'] = 'application/x-www-form-urlencoded';
      // auth改造 代驾接口增加参数domainType=200
      config.data.domainType = 200;
      config.data = qs.stringify(config.data);
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
  // response 拦截器
  axiosBase.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return new Promise((resolve, reject) => {
    axiosBase(config)
      .then((res) => {
        return resolve(res);
      })
      .catch((error) => {
        return reject(error);
      });
  });
};

const axiosExt = (config) => {
  config.method = config.Method || 'POST';
  return new Promise((resolve, reject) => {
    getHost().then((host) => {
      return getAxiosBase(host, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((error) => {
          return reject(error);
        });
    });
  });
};
export { axiosExt };
